/** Contenedor de notificaciones toast (esquina inferior derecha). */
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';
import { useToastStore, type TipoToast } from '@/store/toastStore';
import { cn } from '@/lib/cn';

const ESTILOS: Record<TipoToast, { icono: typeof Info; clase: string }> = {
  exito: { icono: CheckCircle2, clase: 'border-exito bg-exito-suave text-exito dark:bg-exito-suave dark:text-exito' },
  error: { icono: XCircle, clase: 'border-peligro bg-peligro-suave text-peligro dark:bg-peligro-suave dark:text-peligro' },
  info: { icono: Info, clase: 'border-info bg-info-suave text-info dark:bg-info-suave dark:text-info' },
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const quitar = useToastStore((s) => s.quitar);

  return (
    <div aria-live="polite" className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-2">
      {toasts.map((t) => {
        const { icono: Icono, clase } = ESTILOS[t.tipo];
        return (
          <div
            key={t.id}
            className={cn(
              'pointer-events-auto flex items-start gap-3 rounded-lg border-l-4 p-3 shadow-lg',
              clase,
            )}
          >
            <Icono className="mt-0.5 h-5 w-5 shrink-0" />
            <p className="flex-1 text-sm">{t.mensaje}</p>
            <button onClick={() => quitar(t.id)} aria-label="Cerrar notificación" className="app-toolbar-button shrink-0">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
